module.exports = __webpack_public_path__ + "static/media/LightMode.01379dbb.svg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/LightMode.svg
// module id = 283
// module chunks = 0